<div class="flex flex-col gap-2 p-2 w-full">
    <div class="flex flex-col p-2 grow gap-1 bg-ponder-light rounded-md card-shadow"  style="background: linear-gradient(#2d2c3c, #1A1922);">
        <div class="flex flex-col gap-1 p-3 grow">
            <div class="text-center text-sm text-slate-50 font-bold">Cards Per Year</div>
            <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions" [legend]="false"></canvas>
        </div>
    </div>
</div>